// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const jigglypuff: PokeData = {
  "id": 39,
  "name": "jigglypuff",
  "height": 5,
  "weight": 55,
  "base_experience": 95,
  "types": [
    PokeType.NORMAL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "body-slam",
    "double-edge",
    "sing",
    "disable",
    "mimic",
    "defense-curl",
    "bide",
    "rest",
    "sweet-kiss",
    "charm",
    "rollout",
    "stockpile",
    "spit-up",
    "swallow",
    "hyper-voice",
    "covet",
    "wake-up-slap",
    "gyro-ball",
    "copycat",
    "round",
    "echoed-voice",
    "disarming-voice",
    "play-rough",
    "play-nice"
  ],
  "moves": [
    "body-slam",
    "sweet-kiss",
    "hyper-voice",
    "play-rough",
    "growl",
    "moonblast",
    "starfall",
    "moonlight",
    "protect",
    "purification",
    "scratch",
    "refresh",
    "misty-terrain"
  ],
  "evolution_chain": {
    "id": 16,
    "item": null,
    "species": [
      {
        "name": "igglybuff",
        "order": 41,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "jigglypuff",
        "order": 42,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 174,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "wigglytuff",
        "order": 43,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 39,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 68.75,
    "speed": 20,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 170,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
